import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white border border-gray-200 rounded-xl p-4 mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "py-8 flex justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "Admin"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "Action Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "Entity Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "Entity ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "School"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-3 text-left text-xs text-gray-600 font-medium" }, "Note")
  ])
], -1)
const _hoisted_6 = ["onClick", "onKeydown"]
const _hoisted_7 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_8 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_9 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_10 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_11 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_12 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_13 = { class: "px-3 py-3 text-xs text-gray-700" }
const _hoisted_14 = {
  key: 0,
  class: "text-sm text-gray-500 py-6 text-center"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-4 flex justify-between items-center"
}
const _hoisted_16 = { class: "text-sm text-gray-600" }
const _hoisted_17 = ["disabled"]

import { ActivityLog } from "@/interfaces/activity-log.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogsTableComponent',
  props: {
    logs: {},
    loading: { type: Boolean },
    loadingMore: { type: Boolean },
    hasMore: { type: Boolean },
    total: {}
  },
  emits: ["showMore", "selectLog"],
  setup(__props: any) {





const formatDate = (value: string) => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toISOString().replace("T", " ").substring(0, 19);
};

const adminName = (log: ActivityLog) => {
  if (log.actorDetails?.firstName || log.actorDetails?.lastName) {
    return `${log.actorDetails?.firstName || ""} ${log.actorDetails?.lastName || ""}`.trim();
  }

  return log.actorDetails?.email || log.actorId || "-";
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading && _ctx.logs.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_spinner_loader, { color: 'text-blue-600 dark:text-blue-600' })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: log._id,
                  class: _normalizeClass([
              index % 2 === 1 ? 'bg-gray-100' : '',
              'cursor-pointer hover:bg-blue-50 transition-colors'
            ]),
                  role: "button",
                  tabindex: "0",
                  title: "View metadata",
                  onClick: ($event: any) => (_ctx.$emit('selectLog', log)),
                  onKeydown: [
                    _withKeys(($event: any) => (_ctx.$emit('selectLog', log)), ["enter"]),
                    _withKeys(_withModifiers(($event: any) => (_ctx.$emit('selectLog', log)), ["prevent"]), ["space"])
                  ]
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(formatDate(log.createdAt)), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(adminName(log)), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(log.actionType || '-'), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(log.entityType || '-'), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(log.entityId || '-'), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(log.school?.name || '-'), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(log.details?.note || '-'), 1)
                ], 42, _hoisted_6))
              }), 128))
            ])
          ]),
          (_ctx.logs.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No activity logs found. "))
            : _createCommentVNode("", true),
          (_ctx.logs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("p", _hoisted_16, " Showing " + _toDisplayString(_ctx.logs.length) + " of " + _toDisplayString(_ctx.total), 1),
                (_ctx.hasMore)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "text-gray-700 text-sm font-semibold border border-gray-300 px-4 py-2 bg-white rounded-lg disabled:opacity-50 flex items-center gap-2",
                      disabled: _ctx.loadingMore,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMore')))
                    }, [
                      (_ctx.loadingMore)
                        ? (_openBlock(), _createBlock(_component_spinner_loader, {
                            key: 0,
                            color: 'text-blue-600 dark:text-blue-600'
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_ctx.loadingMore ? 'Loading...' : 'Show More'), 1)
                    ], 8, _hoisted_17))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})